/**
 * 관리자 비밀번호 입력 표시/숨김 토글.
 * 마크업: .admin-auth__password-wrap > input + button.admin-auth__password-toggle > .admin-auth__toggle-icon > i.fa-eye
 * 로그인/회원가입/사용자(생성·수정·비밀번호 변경) 등 토글 버튼이 있는 모든 관리자 폼에 전역 적용.
 */

const TOGGLE_SELECTOR = ".admin-auth__password-toggle";
const WRAP_SELECTOR = ".admin-auth__password-wrap";

const LABEL_SHOW = "비밀번호 보기";
const LABEL_HIDE = "비밀번호 숨기기";

function bindToggle(button: HTMLButtonElement): void {
  if (button.dataset.toggleBound === "1") return;
  button.dataset.toggleBound = "1";

  const wrap = button.closest<HTMLElement>(WRAP_SELECTOR);
  const input = wrap?.querySelector<HTMLInputElement>("input");
  if (!input) return;

  const iconSpan = button.querySelector<HTMLElement>(".admin-auth__toggle-icon");

  button.setAttribute("aria-pressed", "false");

  button.addEventListener("click", () => {
    const show = input.type === "password";
    input.type = show ? "text" : "password";

    // FA JS 방식에서 <i>가 <svg>로 교체되므로 innerHTML 교체로 재트리거
    if (iconSpan) {
      iconSpan.innerHTML = `<i class="fa-regular ${show ? "fa-eye-slash" : "fa-eye"}" aria-hidden="true"></i>`;
    }

    const label = show ? LABEL_HIDE : LABEL_SHOW;
    button.setAttribute("aria-label", label);
    button.setAttribute("title", label);
    button.setAttribute("aria-pressed", show ? "true" : "false");
  });
}

export function initAdminPasswordToggle(): void {
  document
    .querySelectorAll<HTMLButtonElement>(TOGGLE_SELECTOR)
    .forEach(bindToggle);
}
